import Logger from '../Logger';
import {
  ActivateLeadEventData,
  AddPaymentInfoEventData,
  AddShippingInfoEventData,
  ApplyCouponEventData,
  BeginCheckoutEventData,
  ChangeConfigurationEventData,
  GenerateLeadEventData,
  ITrackingService,
  PurchaseEventData,
  SelectProductEventData,
  ViewConfigurationEventData,
  ViewConfigurationSummaryEventData,
  ViewProductEventData,
  ViewProductListEventData,
} from './types';

export class Analytics {
  private static services: Array<ITrackingService> = [];

  public static safeInvoke(func: (service: ITrackingService) => void) {
    Analytics.services.forEach((s) => {
      try {
        func(s);
      } catch (e) {
        Logger.exception(`For ${Object.getPrototypeOf(s).name} there was an error`, e);
      }
    });
  }

  public static addService(service: ITrackingService) {
    Analytics.services.push(service);
  }

  public static trackActivateLead(data: ActivateLeadEventData): void {
    Analytics.safeInvoke((x) => x.trackActivateLead(data));
  }

  public static trackGenerateLead(data: GenerateLeadEventData): void {
    Analytics.safeInvoke((x) => x.trackGenerateLead(data));
  }

  public static trackViewConfiguration(data: ViewConfigurationEventData): void {
    Analytics.safeInvoke((x) => x.trackViewConfiguration(data));
  }

  public static trackChangeConfiguration(data: ChangeConfigurationEventData): void {
    Analytics.safeInvoke((x) => x.trackChangeConfiguration(data));
  }

  public static trackViewConfigurationSummary(data: ViewConfigurationSummaryEventData): void {
    Analytics.safeInvoke((x) => x.trackViewConfigurationSummary(data));
  }

  public static trackViewProductList(data: ViewProductListEventData): void {
    Analytics.safeInvoke((x) => x.trackViewProductList(data));
  }

  public static trackSelectProduct(data: SelectProductEventData): void {
    Analytics.safeInvoke((x) => x.trackSelectProduct(data));
  }

  public static trackViewProduct(data: ViewProductEventData): void {
    Analytics.safeInvoke((x) => x.trackViewProduct(data));
  }

  public static trackBeginCheckout(data: BeginCheckoutEventData): void {
    Analytics.safeInvoke((x) => x.trackBeginCheckout(data));
  }

  public static trackApplyCoupon(data: ApplyCouponEventData): void {
    Analytics.safeInvoke((x) => x.trackApplyCoupon(data));
  }

  public static trackAddShippingInfo(data: AddShippingInfoEventData): void {
    Analytics.safeInvoke((x) => x.trackAddShippingInfo(data));
  }

  public static trackAddPaymentInfo(data: AddPaymentInfoEventData): void {
    Analytics.safeInvoke((x) => x.trackAddPaymentInfo(data));
  }

  public static trackPurchase(data: PurchaseEventData): void {
    Analytics.safeInvoke((x) => x.trackPurchase(data));
  }
}
